import { useEffect, useRef, useState } from 'react'

export const useTimer = () => {
	const [timer, setTimer] = useState({ minutes: 0, seconds: 0 })
	const timerRef = useRef<ReturnType<typeof setInterval>>()

	const startTimer = () => {
		setTimer({ minutes: 0, seconds: 0 })
		timerRef.current = setInterval(() => {
			setTimer(prev => {
				const newSeconds = prev.seconds + 1
				if (newSeconds >= 60) {
					return { minutes: prev.minutes + 1, seconds: 0 }
				}
				return { ...prev, seconds: newSeconds }
			})
		}, 1000)
	}

	const clearTimer = () => {
		if (timerRef.current) {
			clearInterval(timerRef.current)
		}
	}

	useEffect(() => {
		return () => clearTimer()
	}, [])

	return { timer, startTimer, clearTimer }
}
